import { PermissionsCategory } from "src/app/auth/permissions";

@PermissionsCategory("ParentSurveyPermissions")
export class ParentSurveyPermissions {
    static readonly None = 0;
    static readonly View = 1;
    static readonly EditDataInput = 2;
    static readonly EditSurvey = 3;
}
